import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { type RowClient } from 'entities/Clients/model/RowClient'
import { useClientsViewContext } from 'pages/clients/context/clientsPageContext'
import { activeClientsColumns } from 'pages/clients/ui/ActiveClients/columns'
import { getClientRowActions, CLIENT_ROW_GROUP_ORDER } from 'pages/clients/ui/actions'
import { ClientsTable } from 'pages/clients/ui/ClientsTable/ClientsTable'

export const ActiveClientsTab = observer(() => {
  const { activeClientsTabStore } = useClientsViewContext()
  const { tableStore, itemsRows, init, scrollToTopTrigger, dispose } = activeClientsTabStore

  useEffect(() => {
    init()
    return () => {
      dispose()
    }
  }, [])

  const rows = itemsRows.map((row) => {
    const dropdownWidth = !row.accessibleOrganization ? 160 : undefined

    row.setActionsProps({
      actions: getClientRowActions(row, activeClientsTabStore),
      groupOrder: CLIENT_ROW_GROUP_ORDER,
      enableGrouping: true,
      dropdownWidth,
    })

    return row
  })

  return (
    <ClientsTable<RowClient>
      tableStore={tableStore}
      rows={rows}
      columns={activeClientsColumns}
      scrollToTopTrigger={scrollToTopTrigger}
    />
  )
})
